import { render, staticRenderFns } from "./FlagPortugal.vue?vue&type=template&id=35b401be&"
import script from "./FlagPortugal.vue?vue&type=script&lang=js&"
export * from "./FlagPortugal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports